import type { Abi } from "viem";

export const gatewayV1Abi: Abi = [
    { inputs: [], stateMutability: "nonpayable", type: "constructor" },
    { inputs: [], name: "EnforcedPause", type: "error" },
    { inputs: [], name: "ExpectedPause", type: "error" },
    { inputs: [], name: "InvalidZapFee", type: "error" },
    { inputs: [], name: "InvalidZapRouter", type: "error" },
    {
        inputs: [
            { internalType: "uint256", name: "min", type: "uint256" },
            { internalType: "uint256", name: "actual", type: "uint256" },
        ],
        name: "MinAssetsOutError",
        type: "error",
    },
    { inputs: [], name: "PendingLossesUnapplied", type: "error" },
    { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
    {
        inputs: [{ internalType: "address", name: "token", type: "address" }],
        name: "SafeERC20FailedOperation",
        type: "error",
    },
    { inputs: [], name: "SwapFailed", type: "error" },
    {
        inputs: [{ internalType: "bytes", name: "returnData", type: "bytes" }],
        name: "UnderlyingCallReverted",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: "uint256", name: "timestamp", type: "uint256" },
            { indexed: true, internalType: "string", name: "name", type: "string" },
            { indexed: false, internalType: "address", name: "_address", type: "address" },
        ],
        name: "AddressSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "oldCore", type: "address" },
            { indexed: true, internalType: "address", name: "newCore", type: "address" },
        ],
        name: "CoreUpdate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: "address", name: "account", type: "address" }],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: "uint256", name: "timestamp", type: "uint256" },
            { indexed: false, internalType: "address", name: "router", type: "address" },
            { indexed: false, internalType: "bool", name: "enabled", type: "bool" },
        ],
        name: "SetEnabledRouter",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: "address", name: "account", type: "address" }],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: "uint256", name: "timestamp", type: "uint256" },
            { indexed: false, internalType: "uint256", name: "zapFee", type: "uint256" },
        ],
        name: "ZapFeeSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: "uint256", name: "timestamp", type: "uint256" },
            { indexed: true, internalType: "address", name: "user", type: "address" },
            { indexed: true, internalType: "address", name: "token", type: "address" },
            { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
            { indexed: false, internalType: "uint256", name: "receiptTokens", type: "uint256" },
        ],
        name: "ZapIn",
        type: "event",
    },
    {
        inputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
        name: "addresses",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "_unwindingTimestamp", type: "uint256" },
            { internalType: "uint32", name: "_newUnwindingEpochs", type: "uint32" },
        ],
        name: "cancelUnwinding",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    { inputs: [], name: "claimRedemption", outputs: [], stateMutability: "nonpayable", type: "function" },
    {
        inputs: [],
        name: "core",
        outputs: [{ internalType: "contract InfiniFiCore", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "_amount", type: "uint256" },
            { internalType: "uint32", name: "_unwindingEpochs", type: "uint32" },
            { internalType: "address", name: "_recipient", type: "address" },
        ],
        name: "createPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    { internalType: "address", name: "target", type: "address" },
                    { internalType: "uint256", name: "value", type: "uint256" },
                    { internalType: "bytes", name: "callData", type: "bytes" },
                ],
                internalType: "struct CoreControlled.Call[]",
                name: "calls",
                type: "tuple[]",
            },
        ],
        name: "emergencyAction",
        outputs: [{ internalType: "bytes[]", name: "returnData", type: "bytes[]" }],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "", type: "address" }],
        name: "enabledRouters",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "string", name: "_name", type: "string" }],
        name: "getAddress",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint32", name: "_oldUnwindingEpochs", type: "uint32" },
            { internalType: "uint32", name: "_newUnwindingEpochs", type: "uint32" },
            { internalType: "uint256", name: "_shares", type: "uint256" },
        ],
        name: "increaseUnwindingEpochs",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "_core", type: "address" }],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_to", type: "address" },
            { internalType: "uint256", name: "_amount", type: "uint256" },
        ],
        name: "mint",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_to", type: "address" },
            { internalType: "uint256", name: "_amount", type: "uint256" },
            { internalType: "uint32", name: "_unwindingEpochs", type: "uint32" },
        ],
        name: "mintAndLock",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_to", type: "address" },
            { internalType: "uint256", name: "_amount", type: "uint256" },
        ],
        name: "mintAndStake",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address[]", name: "_assets", type: "address[]" },
            { internalType: "uint32[]", name: "_unwindingEpochs", type: "uint32[]" },
            {
                components: [
                    { internalType: "address", name: "farm", type: "address" },
                    { internalType: "uint96", name: "weight", type: "uint96" },
                ],
                internalType: "struct AllocationVoting.AllocationVote[][]",
                name: "_liquidVotes",
                type: "tuple[][]",
            },
            {
                components: [
                    { internalType: "address", name: "farm", type: "address" },
                    { internalType: "uint96", name: "weight", type: "uint96" },
                ],
                internalType: "struct AllocationVoting.AllocationVote[][]",
                name: "_illiquidVotes",
                type: "tuple[][]",
            },
        ],
        name: "multiVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    { inputs: [], name: "pause", outputs: [], stateMutability: "nonpayable", type: "function" },
    {
        inputs: [],
        name: "paused",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_to", type: "address" },
            { internalType: "uint256", name: "_amount", type: "uint256" },
            { internalType: "uint256", name: "_minAssetsOut", type: "uint256" },
        ],
        name: "redeem",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "string", name: "_name", type: "string" },
            { internalType: "address", name: "_address", type: "address" },
        ],
        name: "setAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "newCore", type: "address" }],
        name: "setCore",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_router", type: "address" },
            { internalType: "bool", name: "_enabled", type: "bool" },
        ],
        name: "setEnabledRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "uint256", name: "_zapFee", type: "uint256" }],
        name: "setZapFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_to", type: "address" },
            { internalType: "uint256", name: "_receiptTokens", type: "uint256" },
        ],
        name: "stake",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "_shares", type: "uint256" },
            { internalType: "uint32", name: "_unwindingEpochs", type: "uint32" },
        ],
        name: "startUnwinding",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    { inputs: [], name: "unpause", outputs: [], stateMutability: "nonpayable", type: "function" },
    {
        inputs: [
            { internalType: "address", name: "_to", type: "address" },
            { internalType: "uint256", name: "_stakedTokens", type: "uint256" },
        ],
        name: "unstake",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_to", type: "address" },
            { internalType: "uint256", name: "_amount", type: "uint256" },
            { internalType: "uint32", name: "_unwindingEpochs", type: "uint32" },
        ],
        name: "unstakeAndLock",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_asset", type: "address" },
            { internalType: "uint32", name: "_unwindingEpochs", type: "uint32" },
            {
                components: [
                    { internalType: "address", name: "farm", type: "address" },
                    { internalType: "uint96", name: "weight", type: "uint96" },
                ],
                internalType: "struct AllocationVoting.AllocationVote[]",
                name: "_liquidVotes",
                type: "tuple[]",
            },
            {
                components: [
                    { internalType: "address", name: "farm", type: "address" },
                    { internalType: "uint96", name: "weight", type: "uint96" },
                ],
                internalType: "struct AllocationVoting.AllocationVote[]",
                name: "_illiquidVotes",
                type: "tuple[]",
            },
        ],
        name: "vote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "uint256", name: "_unwindingTimestamp", type: "uint256" }],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "zapFee",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_token", type: "address" },
            { internalType: "uint256", name: "_amount", type: "uint256" },
            { internalType: "address", name: "_router", type: "address" },
            { internalType: "bytes", name: "_routerData", type: "bytes" },
            { internalType: "address", name: "_to", type: "address" },
        ],
        name: "zapIn",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_token", type: "address" },
            { internalType: "uint256", name: "_amount", type: "uint256" },
            { internalType: "address", name: "_router", type: "address" },
            { internalType: "bytes", name: "_routerData", type: "bytes" },
            { internalType: "uint32", name: "_unwindingEpochs", type: "uint32" },
            { internalType: "address", name: "_to", type: "address" },
        ],
        name: "zapInAndLock",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_token", type: "address" },
            { internalType: "uint256", name: "_amount", type: "uint256" },
            { internalType: "address", name: "_router", type: "address" },
            { internalType: "bytes", name: "_routerData", type: "bytes" },
            { internalType: "address", name: "_to", type: "address" },
        ],
        name: "zapInAndStake",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "payable",
        type: "function",
    },
];
